// Translator notes: languages and names written with a small letter (engine/src/languages.ts, rules/languages.ts).
// Each id is an engine note (`notes.add(text, id, args)`); `args` names its arguments in the order the strings take them.
// Collected by translator/notes.ts (import.meta.glob): adding a note means adding it here.
import { defineNotes } from '../note-defs';

/** " (Farāsi)" after the name when the High Valyrian name differs from it. */
const hvAfter = (name: string | undefined, hv: string | undefined) => (hv && hv !== name ? ` (${hv})` : '');

export const notes = defineNotes({
  languageName: {
    args: ['word', 'place', 'phrase'],
    fi: (a: string[]) =>
      `”${a[0]}” on tässä kieli, valyriaksi ${a[2]}: udrir ’puhe, kieli’ ja ${a[1]} genetiivissä. Malli on Petersonin (Valyrio udrir ’valyrian kieli’), ilmaus on meidän.`,
    en: (a) =>
      `“${a[0]}” is the language here, in Valyrian ${a[2]}: udrir ‘speech, language’ with ${a[1]} in the genitive. The pattern is Peterson's (Valyrio udrir ‘the Valyrian language’); the phrase is ours.`,
  },
  lowercaseName: {
    args: ['word', 'name', 'hv'],
    fi: (a: string[]) => `”${a[0]}” on kirjoitettu pienellä alkukirjaimella, joten sitä ei lueta nimeksi ${a[1]}${hvAfter(a[1], a[2])}.`,
    en: (a) => `“${a[0]}” is written with a small letter, so it is not read as the name ${a[1]}${hvAfter(a[1], a[2])}.`,
  },
});

declare module '../note-defs' {
  interface NoteIds extends Record<keyof typeof notes, true> {}
}
